export default {
	phoneBlocker: {
		message: "Diese Seite funktioniert nicht auf dem Smartphone.",
		backToDashboard: "Zurück zum Dashboard",
	},
	apiDocs: {
		loading: "Die API-Beschreibung wird geladen.",
		forbidden: "Du hast keine Berechtigung für die API-Beschreibung.",
		notBuilt: "Die API-Beschreibung ist noch nicht erstellt. Das Deployment hat die Datei noch nicht gebaut.",
		loadFailed: "Die API-Beschreibung konnte nicht geladen werden.",
	},
};
